<template>
  <div class="spend-content ">
    <div class="spend-content-head">
      <div class="spend-head-left"><img :src="imgPath" alt="" srcset=""></div>
      <div class="spend-head-right">
        <div>我的会员ID：{{userInfo.mid}}</div>
        <div>已消费{{userInfo.spendtimes}}次，共{{userInfo.spendamount}}元</div>
        <div>当前余额：<span>￥{{userInfo.balance}}</span></div>
      </div>
    </div>
    <div class="spend-content-list">
      <!-- <p><span class="nut-textinput-label">消费总额：</span><input type="number" placeholder="请输入金额" style="outline: none;" v-model="value" :disabled="false" ></p> -->
      <nut-textinput type='number' v-model="value" label="消费总额：" placeholder="请输入金额" :disabled="false" />
      <p v-if="value!==''" style="margin-top:24px;">支付金额：<span style="color:#f00;">￥{{value}}</span></p>
    </div>
    <div class="pay-rule">
      会员卡使用规则：<br/>
      1、不可转让使用；<br/>
      2、会员金额必须大于或者等于买单金额才可享受会员优惠，会员金额不够抵扣买单金额时，可原价使用会员卡剩余金额，不享受会员折扣；<br/>
      （最终解释权归商家所有）
    </div>
    <div class="spend-btn">
      <div class="pay-contnet">
        <div class="pay-top">
          <div class="pay-top-left">
            <el-button :disabled="value ===''" @click="requestPay" type="success">会员余额支付</el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="交易详情" :show-close='false' class="success-dialog" fullscreen :visible.sync="show">
      <div class="success-vessel">
        <div class="success-icon"></div>
        <div class="success-text">支付成功</div>
        <div class="success-amount">￥{{value | format}}</div>
        <div class="success-btn">
          <el-button @click="requestSuccess" type="success">完成</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getUserInfo } from '@/views/mobile/MemberCenter/apis'
import { preSpend } from '@/views/mobile/PublicApp/apis'
const shopNameGroup = {
  gzahh: require('../assets/images/logo.png'),
  gzwyh: require('../assets/images/logo.png'),
  zhfh: require('../assets/images/logo.png'),
  hzhb: require('../assets/images/logo.png'),
  fzth: require('../assets/images/logo.png'),
  szty: require('../assets/images/szty.jpg'),
  test: require('../assets/images/logo.png'),
  test2: require('../assets/images/logo.png')
}
export default {
  data () {
    return {
      userInfo: {},
      value: '',
      shopName: '',
      shopflag: '',
      show: false,
      imgPath: '',
      isClick: true
    }
  },
  filters: {
    format (value) {
      if (value !== '') {
        return Number(value).toFixed(2)
      } else {
        return ''
      }
    }
  },
  methods: {
    requestUserInfo () {
      this.loading = this.$toast.loading()
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      getUserInfo(data)
        .then(result => {
          this.loading.hide()
          if (result) {
            this.userInfo = result.data
            this.shopName = result.data.ext.shopname
            this.shopflag = result.data.ext.shopflag
            // this.shopflag = 'szty'
            this.imgPath = shopNameGroup[this.shopflag]
            if (this.userInfo.mobile === '') {
              let that = this
              this.$dialog({
                closeBtn: false,
                noCancelBtn: true,
                id: 'pay-id',
                okBtnTxt: '前往修改',
                title: '温馨提示',
                content: '为保证资金安全，请务必如实填写个人信息',
                onOkBtn (event) {
                  this.close()
                  that.$router.push('/public/personal')
                }
              })
            }
            localStorage.setItem('ms_userInfo', JSON.stringify(result.data))
            let userInfo = JSON.parse(localStorage.getItem('ms_userInfo'))
            if (userInfo.ext.shopflag === 'szty') {
              document.title = '陶源酒家'
            } else if (userInfo.ext.shopname !== '') {
              document.title = userInfo.ext.shopname
            } else {
              document.title = '香港富临皇宫'
            }
          }
        }).catch(error => {
          if (error) {
            this.loading.hide()
          }
        })
    },
    requestPay () {
      let title = '￥' + Number(this.value).toFixed(2)
      let that = this
      this.isClick = true
      this.$dialog({
        id: 'pay-dialog',
        title: title,
        content: '确认支付金额',
        closeBtn: true,
        onOkBtn (event) {
          this.close()
          if (that.isClick) {
            that.requestPrespend()
            that.isClick = false
          } else {
            return false
          }
        }
      })
    },
    requestPrespend () {
      let data = new FormData()
      data.append('fromUrl', window.location.href)
      data.append('amount', this.value)
      data.append('shop_id', this.$route.query.id)
      preSpend(data)
        .then(result => {
          if (result) {
            this.requestUserInfo()
            this.show = true
            // this.$toast.success('支付成功！')
          }
        })
    },
    requestSuccess () {
      this.$router.push('/memberCenter')
    }
  },
  mounted () {
    this.requestUserInfo()
  },
  created () {
  }
}
</script>
<style lang="less">
#pay-dialog {
  .nut-dialog-ok {
    background: linear-gradient(315deg, #68c937 0%, #67c23a 100%) !important;
  }
  .nut-dialog-ok:active {
    background: inherit;
  }
}
.success-dialog {
  padding-top: 0;
  .el-dialog__header {
    display: none;
    background: #333;
    padding: 10px 20px;
    .el-dialog__title {
      color: #fff;
      font-size: 16px;
    }
  }
  .success-vessel {
    position: absolute;
    left: 0;
    top: 100px;
    width: 100%;
  }
  .success-text {
    color: #67c23a;
    text-align: center;
    margin-top: 20px;
    font-size: 20px;
  }
  .success-amount {
    text-align: center;
    margin-top: 30px;
    font-size: 36px;
    color: #000;
  }
  .success-icon {
    width: 100px;
    height: 100px;
    margin: 0 auto;
    background-image: url(../assets/images/success.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100%;
  }
  .success-btn {
    padding: 0 30px;
    margin-top: 50px;
    box-sizing: border-box;
    .el-button {
      width: 100%;
      margin: 0 auto;
      font-size: 18px;
    }
  }
}
.spend-content {
  font-size: 15px;
  height: 100%;
  .spend-content-head {
    padding: 32px 0 32px 32px;
    overflow: hidden;
    border-bottom: 1px solid #ddd;
    .spend-head-left {
      height: 80px;
      width: 80px;
      float: left;
      margin-right: 32px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      img {
        display: block;
        float: left;
        width: 100%;
      }
    }
    .spend-head-right {
      float: left;
      line-height: 26px;
      span {
        color: #f00;
      }
    }
  }
  .spend-content-list {
    padding: 16px;
    input {
      height: 40px;
      font-size: 14px;
      border-radius: 4px;
      border: 1px solid #dddfe6;
      background-color: "#FFFFFF";
      padding: 0 0 0 10px;
    }
  }
  .spend-btn {
    position: fixed;
    bottom: 0;
    background: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 24px 16px;
    width: 100%;
    max-width: 750px;
    .pay-contnet {
      .pay-top {
        overflow: hidden;
        .pay-top-left,
        .pay-top-right {
          float: left;
          width: 100%;
          text-align: center;
          padding: 0;
          // padding-right: 8px;
          .el-button {
            width: 100%;
            font-size: 18px;
          }
        }
        .pay-top-right {
          padding: 0;
          padding-left: 8px;
        }
      }
    }
  }
  .pay-rule{
    font-size: 13px;
    margin-top: 50px;
    padding: 0 16px;
    line-height: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/mobile/PublicApp/components/Spend.vue